/**
 * Request ids are always either numeric (server-assigned) or an offline
 * `o-<n>` id (see `offlineCache.ts`). On web the id is read from the URL query
 * string, which is untrusted input. Strip anything outside the safe charset
 * before the id flows downstream so crafted location input cannot reach a
 * code-execution sink (CWE-94, #1579).
 *
 * The allowed set (`[a-zA-Z0-9_-]`) is a strict superset of every valid id, so
 * this is a no-op for legitimate values and returns the input unchanged when it
 * is `null`/`undefined`/empty. The return type mirrors the input type.
 */
export const sanitizeRequestId = <T extends string | null | undefined>(
  id: T,
): T => (id ? (id.replace(/[^a-zA-Z0-9_-]/g, '') as T) : id);
